import Scene = Phaser.Scene;
import {Amount} from "@/model/amount";
import {ResourceType} from "@/store/place/types";
import ResourceUtils from "@/utils/resource-utils";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import SkillUtils from "@/utils/skill-utils";
import CU from "@/utils/c-u";

export default class PricePanel extends Phaser.GameObjects.Container {

    private static readonly ICON_SHIFT_Y = 6;

    private static readonly CELL_SIZE_X = 60;
    private static readonly CELL_SIZE_Y = 40;

    constructor(scene: Scene, x: number, y: number, amount: Amount,
                color: string = '#ffffff', size: number = 17, font: string = Fonts.MYRIADPRO_BOLD) {
        super(scene);
        let self = this;

        this.scene = scene;
        this.x = x;
        this.y = y;

        let resources: Map<ResourceType, number> = ResourceUtils.convert(amount);

        let group = this.scene.add.group();

        for (let [key, value] of resources) {

            const resText = TextUtils.addTextAdvanced(scene, SkillUtils.formatMoreThanMillion(value), 0, 8,
                color, size, 'normal', 150, 'center', 2, font);

            const resIcon = SpriteUtils.addImage(this.scene, resText.getLeftCenter().x! / CU.S - 18, PricePanel.ICON_SHIFT_Y + 2, ResourceUtils.getResourceImageId(key));
            SpriteUtils.setDispSize(resIcon, 40 * CU.S, 40 * CU.S);

            let container = this.scene.add.container(0, 0, [resIcon, resText]);
            group.add(container);
            self.add(container);
        }

        let count = group.getChildren().length;

        Phaser.Actions.GridAlign(group.getChildren(), {
            cellWidth: PricePanel.CELL_SIZE_X * CU.S,
            cellHeight: PricePanel.CELL_SIZE_Y * CU.S,
            x: - PricePanel.CELL_SIZE_X * CU.S / 2,
            y: - PricePanel.CELL_SIZE_Y * CU.S / 2
        });

        for (let obj of group.getChildren()) {
            this.add(obj);
        }
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }
}
